__webpack_require__.p = "/magellan/";